import React from 'react';

let qs = [
  {
    question: () => (
      <div>
        Kad se javlja
        <br />
        usamljenost?
      </div>
    ),
    correct: 2,
    answers: [
      <span>Samo kad smo sami</span>,
      <span>Kad nemamo prijatelje</span>,
      <span>Kad se ne osjećamo blisko s drugima</span>,
    ],
  },

  {
    question: () => <div>Koja je prednost samoće?</div>,
    correct: 0,
    answers: [
      <span>Možemo razvijati svoju kreativnost</span>,
      <span>Možemo izbjeći sve loše emocije</span>,
      <span>Samoća nema prednosti</span>,
    ],
  },

  {
    question: () => <div>Što sve spada u sliku o sebi?</div>,
    correct: 2,
    answers: [
      <span>Kako izgledamo i čime se bavimo</span>,
      <span>Samopoštovanje i samopouzdanje</span>,
      <span>Sve od navedenog</span>,
    ],
  },

  {
    question: () => <div>Kakve mogu biti emocije?</div>,
    correct: 1,
    answers: [
      <span>Pozitivne i negativne</span>,
      <span>Ugodne i neugodne</span>,
      <span>Dobre i loše</span>,
    ],
  },
  {
    question: () => <div>Trebamo li se isticati ako smo u nečemu dobri?</div>,
    correct: 0,
    answers: [
      <span>Da, tako jačamo samopouzdanje</span>,
      <span>Da, ali samo ako smo najbolji</span>,
      <span>Ne, trebamo biti skromni</span>,
    ],
  },
  {
    question: () => <div>Što je bullying?</div>,
    correct: 1,
    answers: [
      <span>Bezazleno zadirkivanje</span>,
      <span>Nasilje nad vršnjacima</span>,
      <span>Iskustvo od kojeg netko “ojača”</span>,
    ],
  },
  {
    question: () => <div>Kako se bullying može riješiti?</div>,
    correct: 2,
    answers: [
      <span>Ignoriranjem</span>,
      <span>Isprikom</span>,
      <span>Traženjem pomoći</span>,
    ],
  },
  {
    question: () => <div>Što je ispitna anksioznost?</div>,
    correct: 1,
    answers: [
      <span>Svaka trema pred ispit</span>,
      <span>Strah prije, tijekom i nakon ispita</span>,
      <span>Uzbuđenje prije, tijekom i nakon ispita</span>,
    ],
  },
  {
    question: () => <div>Ljutnju trebamo:</div>,
    correct: 1,
    answers: [
      <span>Izraziti, pa makar i ako povrijedimo nekoga</span>,
      <span>Izraziti, ali na siguran način</span>,
      <span>Ignorirati</span>,
    ],
  },
  {
    question: () => <div>Kako možemo smanjiti ispitnu anksioznost?</div>,
    correct: 2,
    answers: [
      <span>Nikako, ona je neizbježna</span>,
      <span>Ignoriranjem</span>,
      <span>Planiranjem učenja i tehnikama opuštanja</span>,
    ],
  },
  {
    question: () => <div>Kad osjetimo nalet emocija trebamo ih…</div>,
    correct: 1,
    answers: [
      <span>Odmah izraziti, bez zadrške</span>,
      <span>Prepoznati, a tek onda izraziti</span>,
      <span>Zadržati za sebe</span>,
    ],
  },
  {
    question: () => <div>Samorefleksija je:</div>,
    correct: 1,
    answers: [
      <span>Vlastiti odraz u ogledalu</span>,
      <span>Razmišljanje o sebi</span>,
      <span>Drugi naziv za selfie</span>,
    ],
  },
  {
    question: () => <div>Kako možemo ojačati pozitivnu sliku o sebi?</div>,
    correct: 0,
    answers: [
      <span>Podsjećanjem na svoje jake strane</span>,
      <span>Uspoređivanjem s drugima</span>,
      <span>Prepoznavanjem tuđih mana</span>,
    ],
  },
  {
    question: () => <div>Kako možemo produbiti prijateljstvo?</div>,
    correct: 1,
    answers: [
      <span>Izbjegavanjem sukoba</span>,
      <span>Aktivnim slušanjem</span>,
      <span>Izbjegavanjem priča o problemima</span>,
    ],
  },
  {
    question: () => <div>Kad se upoznajemo s drugima…</div>,
    correct: 0,
    answers: [
      <span>Pomaže pokazati prijateljski stav</span>,
      <span>Nije prirodno imati tremu</span>,
      <span>Trebamo jako stisnuti ruku</span>,
    ],
  },

  {
    question: () => (
      <div>Usamljenost je loš osjećaj koji ne donosi ništa dobro.</div>
    ),
    correct: 1,
    answers: [<span>Da</span>, <span>Ne</span>],
  },

  {
    question: () => <div>Emocije dijelimo na pozitivne i negativne.</div>,
    correct: 1,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => (
      <div>Emocije je potrebno izražavati, a ne potiskivati.</div>
    ),
    correct: 0,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => <div>Tuga je znak slabosti.</div>,
    correct: 1,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => <div>Svi su ljudi vrijedni poštovanja i ljubavi.</div>,
    correct: 0,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => <div>Hobiji su beskorisni ako nismo u njima najbolji.</div>,
    correct: 1,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => <div>Osobu čine postignuća i školski uspjeh.</div>,
    correct: 1,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => (
      <div>Je li potrebno reagirati na svaki oblik bullyinga?</div>
    ),
    correct: 0,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => <div>Emocije i raspoloženja su ista stvar.</div>,
    correct: 1,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => (
      <div>
        Neugodne emocije trebamo prepoznati, prihvatiti i izraziti na siguran
        način.
      </div>
    ),
    correct: 0,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => (
      <div>Tugu trebamo ignorirati ili izraziti samo kad smo sami.</div>
    ),
    correct: 1,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => (
      <div>Slika o sebi je nešto na čemu uvijek možemo raditi.</div>
    ),
    correct: 0,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => (
      <div>
        Samopoštovanje jačamo tako da vježbamo prihvatiti svoje osobine.
      </div>
    ),
    correct: 0,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => (
      <div>Pravi prijatelj ne dijeli svoje probleme s drugima.</div>
    ),
    correct: 1,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
  {
    question: () => (
      <div>
        Prijatelji su osobe kraj kojih se osjećamo prihvaćeno, mirno i sretno.
      </div>
    ),
    correct: 0,
    answers: [<span>Da</span>, <span>Ne</span>],
  },
];

export const questions = qs.map(q => {
  q.fontSize = q.fontSize || 80;
  q.answers = q.answers.map((a, i) => ({
    a,
    i,
    s: 1,
    fontSize: q.answerFontSize || 80,
    cls: q.answerCls || '',
    correct: q.correct === i,
    icon: q.icons ? q.icons[i] : null,
  }));
  return q;
});
